import { ProjectBillingType, ProjectBillingTypeCode } from '@/app/network/models/project';

export function mapProjectBillingTypeToCode(billingType: ProjectBillingType): ProjectBillingTypeCode {
  const mapping: Record<ProjectBillingType, ProjectBillingTypeCode> = {
    hourly: 'H',
    fixedCost: 'F',
    retainer: 'R',
    proBono: 'P'
  };
  return mapping[billingType];
}

export function mapProjectBillingTypeFromCode(code: ProjectBillingTypeCode): ProjectBillingType {
  const mapping: Record<ProjectBillingTypeCode, ProjectBillingType> = {
    H: 'hourly',
    F: 'fixedCost',
    R: 'retainer',
    P: 'proBono'
  };
  return mapping[code];
}

export const PROJECT_BILLING_TYPE_OPTIONS = [
  { value: 'H' as ProjectBillingTypeCode, label: 'Hourly' },
  { value: 'F' as ProjectBillingTypeCode, label: 'Fixed Cost' },
  { value: 'R' as ProjectBillingTypeCode, label: 'Retainer' },
  { value: 'P' as ProjectBillingTypeCode, label: 'Pro Bono' }
];
